import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/404page2.png';
import _imports_1 from '@/assets/images/slice7.png';
const _withScopeId = n => (_pushScopeId("data-v-c41497e0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "main-content"
};
const _hoisted_2 = {
  class: "box"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
  class: "comingSoonImg",
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("div", {
  class: "soonText"
}, "图源 storyset.com")], -1));
const _hoisted_4 = {
  class: "right"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "抱歉，页面丢失", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "slice",
  src: _imports_1,
  alt: ""
}, null, -1));
import { useRouter } from 'vue-router';
// import Header from '@/components/Header'
// import PageFooter from '@/components/PageFooter'

export default {
  __name: 'notFound',
  setup(__props) {
    const router = useRouter();
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).go(0))
      }, "刷新试试？"), _hoisted_6, _createElementVNode("div", {
        class: "link",
        onClick: _cache[1] || (_cache[1] = $event => _unref(router).push('/'))
      }, "返回首页")])])]);
    };
  }
};